import {CfProject, CfProjectMember, CfUser} from "@app-web-central/web/shared/data-access/models";

export class ProjectUtil {
  static replaceProjectAndGetNewProjects(projects: CfProject[] | null, project: CfProject) {
    const newProjects = projects !== null ? [...projects] : [];
    const index = newProjects.findIndex((x) => x.id === project.id);
    if (index === -1) {
      newProjects.push(project);
    } else {
      newProjects[index] = project;
    }
    return newProjects;
  }

  static removeProjectFromActiveProjects(projects: CfProject[] | null, project: CfProject): CfProject[] {
    const newProjects = projects !== null ? [...projects] : [];
    const index = newProjects.findIndex((x) => x.id === project.id);
    newProjects.splice(index, 1);
    return newProjects;
  }

  static replaceProjectLeadAndDefaultAssignee(project: CfProject, users: CfUser[] | null): void {
    project.projectLead = users?.find((x) => x.id === project.projectLeadId);
    project.defaultAssignee = users?.find((x) => x.id === project.defaultAssigneeId);
  }

  static removeProjectPendingRequests(projects: CfProject[], projectId: string, validationCode: string): CfProject[] {
    const newProjects = projects !== null ? [...projects] : [];
    const index = newProjects.findIndex((x) => x.id === projectId);
    if (index === -1) {
      // do nothing.
    } else {
      newProjects[index].pendingInvitations = [...newProjects[index].pendingInvitations]
        .filter((request) => request.validationCode !== validationCode);
      return newProjects;
    }
    return newProjects;
  }

  static buildUserAccessUIObject(projectMember: CfProjectMember, users: CfUser[] | undefined) {
    const user = users?.find((y) => y.id === projectMember.members);
    return {
      fullName: user?.fullName,
      email: user?.email,
      role: projectMember.role,
      imageUrl: user?.avatarUrl,
    };
  }
}
